import {
  EntryProvider,
  LocaleStringDict,
  TCProvider,
  defaultTheme,
  mobileTheme,
  navigatorLocaleToLanguage,
} from '@frontend/mui'
import { BrowserRouter } from 'react-router-dom'
import { ROUTE_URL, TIME_ZONE } from './constants/env'
import { ApolloProvider } from './context/apollo'
import { MeProvider } from './context/me'
import { Pages, entries } from './pages'
import { isMobile } from './utils/chaos'
import { IntlProvider } from '@frontend/t7nd'
import { useLocaleMessage, LocaleDict } from './intl'
import { storage } from '@frontend/helpers'
import { Language } from './generated/apollo'
export const languageStorage = storage<Language>('LANGUAGE')
function App() {
  const windowLanguage = navigatorLocaleToLanguage(window.navigator.language)
  const locale = languageStorage.get() ?? windowLanguage

  const localeMessage = useLocaleMessage(LocaleDict[locale])
  return (
    <BrowserRouter basename={ROUTE_URL}>
      <IntlProvider {...localeMessage} timeZone={TIME_ZONE}>
        <TCProvider
          theme={isMobile() ? mobileTheme : defaultTheme}
          locale={LocaleStringDict[locale]}
        >
          <ApolloProvider>
            <MeProvider>
              <EntryProvider entries={entries}>
                <Pages></Pages>
              </EntryProvider>
            </MeProvider>
          </ApolloProvider>
        </TCProvider>
      </IntlProvider>
    </BrowserRouter>
  )
}

export default App
